// import {ImageLoader} from './images';
import {ShopifyApi} from './api';
import {Loader} from './loader';
import {ProductPage} from './product_page';
import {CollectionPage} from './collection_page';
import {Cart} from './cart';
import {CartPage} from './cart_page';
import {NavigationNew} from "./navigation-new";
import {FreeGift} from "./FreeGift";
import {Upsell} from "./upsell";
import {AddToCartPopup} from "./add_to_cart_popup";
import {BundleCollection} from "./bundle_collection";
import {Mini_Cart_Form} from './mini_cart_form';
import * as globalEvents from './helpers/global-events';
import { Zonos } from './zonos';
(function ($) {
    function init() {
        const
            api = new ShopifyApi(),
            loader = new Loader(api),
            nav = new NavigationNew(),
            cart = new Cart(api);

        nav.init();
        const body = jQuery('body');
        const popupContainer = jQuery('.v4-add-to-cart-popup-container');
        let popup = null;
        if (popupContainer.length !== 0)
            popup = new AddToCartPopup(loader, cart, popupContainer);

        if (body.hasClass('template-product')) {
            new ProductPage(loader, cart, body, popup);
            new Upsell(popup, cart, api, '.v5-upsell-product-page-placeholder', 'select_option', 'product', true, false);
        }
        if (body.hasClass('template-collection') || body.hasClass('template-list-collections'))
            new CollectionPage(loader, cart, body, popup);
        if (body.hasClass('template-cart')) {
            new CartPage(cart, body, api);
            new FreeGift(api, cart);
            // new Upsell(cart, api, '.v5-upsell-cart-page-placeholder', 'cart', 'cart', true);
            // if(ABV4_SETTINGS.upsell.checkout_popup)
            //     new Upsell(cart, api, '.v5-upsell-checkout-placeholder', 'cart', 'checkout', true);
        } else {
            if(!body.hasClass('mini-cart-excluded')){
                const miniCartForm = body.find('.v4-cart-form');
                new Mini_Cart_Form(cart, miniCartForm, api);
            }
        }
        if(body.hasClass('template-page')) {
            const bundleObjInfo = globalEvents.bundleLPprices(),
                bundlesMsrp = $('.pc-price-msrp--js'),
                bundlesDiscountedPrice = $('.pc-price-discounted--js'),
                bundleCurrencySymbol = $('.pc-currency-symbol');

            bundleCurrencySymbol.text(bundleObjInfo.currency_symbol);
            for(let i = 0; i < bundlesMsrp.length; i++) {
                const bundleMsrp = $(bundlesMsrp[i]),
                    bundleClass = bundleMsrp.attr('data-bundle');                
                    bundleMsrp.text(bundleObjInfo[bundleClass].msrp_price); 
            }

            for(let i = 0; i < bundlesDiscountedPrice.length; i++) {
                const bundleDiscountedPrice = $(bundlesDiscountedPrice[i]),
                    bundleClass = bundleDiscountedPrice.attr('data-bundle');
                    bundleDiscountedPrice.text(bundleObjInfo[bundleClass].discounted_price); 
            }
        }
        $('.site-header-wrapper .shopping-cart').addClass('cart_visible');
        // preload cart button disabled
        globalEvents.disabledPreLoadClick();
        if ($('.btn-buynow-bundle').length > 0) {
            new BundleCollection(api, popup);
        }

        new Zonos(cart);

        if (body.attr('id') == 'new-year-new-you-promo-2020' || jQuery('.conversion-page').length)
            new CollectionPage(loader, cart, body, popup);
        window.shopifyApi = api;
        // window.bundle = new Bundle(api, popup);
    }

    $(document).on('turbolinks:load DOMContentLoaded', init);
})(jQuery);
